import {register} from '@shopify/theme-sections';

export default register('stores-map', {
  onLoad() {
    this.options = JSON.parse(this.container.getAttribute('data-map-settings'));

    if (!this.options.apiKey) {
      return;
    }

    // if settings API key -> load Google Maps API script
    this.loadMapScript().then(this.initMap.bind(this));
  },

  loadMapScript() {
    const apiKey = this.options.apiKey;

    return new Promise(function(resolve, reject) {
      const script = document.createElement('script');
      document.body.appendChild(script);
      script.onload = resolve;
      script.onerror = reject;
      script.async = true;
      script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}`;
    });
  },

  initMap() {
    const mapContainer = this.container.querySelector('.map__gmap');
    const center = this.options.center;

    const mapOptions = {
      center,
      zoom: 4,
      controlSize: 24,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: false,
      styles: [
        {
          elementType: 'geometry',
          stylers: [{color: '#f5f5f5'}],
        },
        {
          elementType: 'labels.icon',
          stylers: [{visibility: 'off'}],
        },
        {
          elementType: 'labels.text.fill',
          stylers: [{color: '#616161'}],
        },
        {
          elementType: 'labels.text.stroke',
          stylers: [{color: '#f5f5f5'}],
        },
        {
          featureType: 'administrative.land_parcel',
          elementType: 'labels.text.fill',
          stylers: [{color: '#bdbdbd'}],
        },
        {
          featureType: 'poi',
          elementType: 'geometry',
          stylers: [{color: '#eeeeee'}],
        },
        {
          featureType: 'poi',
          elementType: 'labels.text.fill',
          stylers: [{color: '#757575'}],
        },
        {
          featureType: 'poi.park',
          elementType: 'geometry',
          stylers: [{color: '#e5e5e5'}],
        },
        {
          featureType: 'poi.park',
          elementType: 'labels.text.fill',
          stylers: [{color: '#9e9e9e'}],
        },
        {
          featureType: 'road',
          elementType: 'geometry',
          stylers: [{color: '#ffffff'}],
        },
        {
          featureType: 'road.arterial',
          elementType: 'labels.text.fill',
          stylers: [{color: '#757575'}],
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry',
          stylers: [{color: '#dadada'}],
        },
        {
          featureType: 'road.highway',
          elementType: 'labels.text.fill',
          stylers: [{color: '#616161'}],
        },
        {
          featureType: 'road.local',
          elementType: 'labels.text.fill',
          stylers: [{color: '#9e9e9e'}],
        },
        {
          featureType: 'transit.line',
          elementType: 'geometry',
          stylers: [{color: '#e5e5e5'}],
        },
        {
          featureType: 'transit.station',
          elementType: 'geometry',
          stylers: [{color: '#eeeeee'}],
        },
        {
          featureType: 'water',
          elementType: 'geometry',
          stylers: [{color: '#c9c9c9'}],
        },
        {
          featureType: 'water',
          elementType: 'geometry.fill',
          stylers: [{color: '#e4e4e4'}],
        },
        {
          featureType: 'water',
          elementType: 'labels.text.fill',
          stylers: [{color: '#9e9e9e'}],
        },
      ],
    };

    const map = new google.maps.Map(mapContainer, mapOptions);

    this.getCoordinates(map);
  },

  getCoordinates(map) {
    const addresses = this.options.locations;
    const locations = this.options.centres;
    const geocoder = new google.maps.Geocoder();

    addresses.forEach((address, index) => {
      geocoder.geocode({address: address}, function(results, status) {
        if (status == 'OK') {
          const marker = new google.maps.Marker({
            map: map,
            position: results[0].geometry.location,
            icon: {
              url: 'https://cdn.shopify.com/s/files/1/0091/9532/3470/files/icon-pin.png?v=1691738558',
              anchor: new google.maps.Point(12, 30),
            },
          });

          const contentString = `<p><strong>${locations[index]}</strong></p>`;

          const infowindow = new google.maps.InfoWindow({
            content: contentString,
          });

          marker.addListener('click', function() {
            infowindow.open(map, marker);
          });
        } else {
          console.log('Geocode was not successful, ' + status);
        }
      });
    });
  },
});
